import { render, staticRenderFns } from "./ArmsRegArchiveFillingInfoDetail.vue?vue&type=template&id=e12eb33e&scoped=true&"
import script from "./ArmsRegArchiveFillingInfoDetail.vue?vue&type=script&lang=js&"
export * from "./ArmsRegArchiveFillingInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArmsRegArchiveFillingInfoDetail.vue?vue&type=style&index=0&id=e12eb33e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12eb33e",
  null
  
)

export default component.exports